module.exports = __webpack_public_path__ + "img/uturn.1d03a4ae.png";